// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atc-traffic-info-delivery.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atc-traffic-info-delivery/atc-traffic-info-delivery.js';

mount([g0]);
